module.exports = __webpack_public_path__ + "static/img/5.67077a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/5.png
// module id = EYTG
// module chunks = 0